export const COLORS = {
  teal: '#2DBDB8',
  green: '#34A851',
  blue: '#469FD8',
  deep: '#366EB6',
  purple: '#6C59A6',
  violet: '#8B75D7',
  orange: '#F2673A',
};

export const GLYPHS = {
  dot: (c) => `<circle cx="12" cy="12" r="8" fill="${c}"/>`,
  grid: (c) =>
    `<rect x="4" y="4" width="7" height="7" rx="2" fill="${c}"/><rect x="13" y="4" width="7" height="7" rx="2" fill="${c}" opacity=".55"/><rect x="4" y="13" width="7" height="7" rx="2" fill="${c}" opacity=".55"/><rect x="13" y="13" width="7" height="7" rx="2" fill="${c}"/>`,
  bars: (c) =>
    `<rect x="4" y="11" width="4" height="9" rx="1.5" fill="${c}" opacity=".55"/><rect x="10" y="6" width="4" height="14" rx="1.5" fill="${c}"/><rect x="16" y="9" width="4" height="11" rx="1.5" fill="${c}" opacity=".75"/>`,
  clock: (c) =>
    `<circle cx="12" cy="12" r="8.5" fill="none" stroke="${c}" stroke-width="2.2"/><path d="M12 7.5V12l3 2" stroke="${c}" stroke-width="2.2" fill="none" stroke-linecap="round"/>`,
  mail: (c) =>
    `<rect x="3.5" y="5.5" width="17" height="13" rx="2.5" fill="none" stroke="${c}" stroke-width="2.2"/><path d="M4.5 8l7.5 5 7.5-5" stroke="${c}" stroke-width="2.2" fill="none"/>`,
  doc: (c) =>
    `<rect x="5.5" y="3.5" width="13" height="17" rx="2.5" fill="none" stroke="${c}" stroke-width="2.2"/><path d="M9 9h6M9 13h6M9 17h3.5" stroke="${c}" stroke-width="2" stroke-linecap="round"/>`,
  chat: (c) =>
    `<path d="M4 6a2.5 2.5 0 012.5-2.5h11A2.5 2.5 0 0120 6v8a2.5 2.5 0 01-2.5 2.5H10l-4.5 4v-4H6.5A2.5 2.5 0 014 14z" fill="${c}"/>`,
  heart: (c) =>
    `<path d="M12 20s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.5-7 10-7 10z" fill="${c}"/>`,
  cal: (c) =>
    `<rect x="4" y="5" width="16" height="15" rx="2.5" fill="none" stroke="${c}" stroke-width="2.2"/><path d="M4 10h16M9 4v4M15 4v4" stroke="${c}" stroke-width="2.2"/>`,
  flag: (c) =>
    `<path d="M6 21V4m0 1h11l-2.5 3.5L17 12H6" fill="none" stroke="${c}" stroke-width="2.2" stroke-linejoin="round"/>`,
  bolt: (c) => `<path d="M13 3L5 13.5h5L10.5 21 19 10h-5.5z" fill="${c}"/>`,
  eye: (c) =>
    `<path d="M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12 18 18.2 12 18.2 2.5 12 2.5 12z" fill="none" stroke="${c}" stroke-width="2.1"/><circle cx="12" cy="12" r="2.6" fill="${c}"/>`,
  net: (c) =>
    `<circle cx="12" cy="5.5" r="2.4" fill="${c}"/><circle cx="5.5" cy="17" r="2.4" fill="${c}" opacity=".7"/><circle cx="18.5" cy="17" r="2.4" fill="${c}" opacity=".7"/><path d="M12 8v4m0 0l-5 4m5-4l5 4" stroke="${c}" stroke-width="1.9"/>`,
  shield: (c) =>
    `<path d="M12 3l7.5 3v5.5c0 5-3.5 8.2-7.5 9.5-4-1.3-7.5-4.5-7.5-9.5V6z" fill="none" stroke="${c}" stroke-width="2.2" stroke-linejoin="round"/><path d="M8.8 12l2.3 2.3 4-4.2" stroke="${c}" stroke-width="2.1" fill="none" stroke-linecap="round"/>`,
  radar: (c) =>
    `<circle cx="12" cy="12" r="8.5" fill="none" stroke="${c}" stroke-width="2"/><circle cx="12" cy="12" r="4.5" fill="none" stroke="${c}" stroke-width="1.6" opacity=".6"/><path d="M12 12l5.5-5.5" stroke="${c}" stroke-width="2.1" stroke-linecap="round"/><circle cx="12" cy="12" r="1.6" fill="${c}"/>`,
  warn: (c) =>
    `<path d="M12 4l9 15.5H3z" fill="none" stroke="${c}" stroke-width="2.2" stroke-linejoin="round"/><path d="M12 10v4.5" stroke="${c}" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="17" r="1.2" fill="${c}"/>`,
  spark: (c) =>
    `<path d="M12 3l1.8 5.7L19.5 12l-5.7 1.8L12 19.5l-1.8-5.7L4.5 12l5.7-1.8z" fill="${c}"/>`,
  user: (c) =>
    `<circle cx="12" cy="8.5" r="3.6" fill="${c}"/><path d="M4.5 20a7.5 7.5 0 0115 0" fill="none" stroke="${c}" stroke-width="2.4" stroke-linecap="round"/>`,
  link: (c) =>
    `<path d="M9.5 14.5l5-5M8 16l-1.5 1.5a3.5 3.5 0 01-5-5L5 9m10-3l1.5-1.5a3.5 3.5 0 015 5L18 13" transform="translate(1.5 1)" fill="none" stroke="${c}" stroke-width="2.1" stroke-linecap="round"/>`,
  gear: (c) =>
    `<circle cx="12" cy="12" r="3.2" fill="none" stroke="${c}" stroke-width="2.1"/><path d="M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2.1 2.1m8.6 8.6l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" stroke="${c}" stroke-width="2.1" stroke-linecap="round"/>`,
  key: (c) =>
    `<circle cx="8" cy="14" r="4.2" fill="none" stroke="${c}" stroke-width="2.2"/><path d="M11.5 11.5L20 3.5m-3 2.5l3 3" stroke="${c}" stroke-width="2.2" stroke-linecap="round" fill="none"/>`,
};

export function iconSvg(color, glyph) {
  const fn = GLYPHS[glyph] || GLYPHS.dot;
  return `<svg aria-hidden="true" viewBox="0 0 24 24">${fn(color)}</svg>`;
}

const C = COLORS;

export const SMALL_CELLS = [
  ['Productivity Scoring', 'bars', C.teal],
  ['Hourly Breakdown', 'clock', C.orange],
  ['AI Summaries', 'spark', C.violet],
  ['Team Activity', 'user', C.blue],
  ['App Tracking', 'grid', C.green],
  ['Email Insights', 'mail', C.deep],
  ['Attendance', 'cal', C.purple],
  ['Leave Patterns', 'warn', C.orange],
  ['Engagement Radar', 'radar', C.teal],
  ['Org Graph', 'net', C.blue],
  ["Founder's Report", 'doc', C.purple],
  ['AI Tool Radar', 'radar', C.violet],
  ['Early Warning', 'warn', C.orange],
  ['Comms Health', 'heart', C.green],
  ['Focus Time', 'eye', C.teal],
  ['Meeting Load', 'cal', C.blue],
  ['Goals', 'flag', C.green],
  ['Tasks', 'doc', C.deep],
  ['Reports', 'bars', C.purple],
  ['Integrations', 'link', C.blue],
  ['Single Sign-on', 'key', C.deep],
  ['Alerts', 'bolt', C.orange],
  ['Roles', 'user', C.purple],
  ['Audit Log', 'doc', C.green],
  ['Data Residency', 'shield', C.teal],
  ['Mobile', 'grid', C.violet],
  ['Search', 'eye', C.deep],
  ['Timesheets', 'clock', C.green],
  ['API', 'gear', C.blue],
  ['Exports', 'doc', C.orange],
  ['Anomaly Feed', 'warn', C.violet],
  ['Workload', 'bars', C.blue],
  ['Notifications', 'bolt', C.teal],
  ['Holidays', 'cal', C.orange],
  ['Payroll', 'doc', C.deep],
  ['Shift Planner', 'clock', C.purple],
];

export const BIG_TILES = [
  {
    n: 'Patterns',
    c: C.teal,
    shot: `<div class="mshead"></div><div class="msrow w1" style="background:#d5f3f1"></div><div class="msrow w2"></div><div class="msrow w3" style="background:#d5f3f1"></div><span class="mstag" style="width:44px;background:#2DBDB8;opacity:.85"></span><span class="mstag" style="width:30px;background:#F2A73A;opacity:.7"></span>`,
    ic: `<svg aria-hidden="true" viewBox="0 0 24 24"><rect x="4" y="11" width="4" height="9" rx="1.5" fill="#fff" opacity=".7"/><rect x="10" y="6" width="4" height="14" rx="1.5" fill="#fff"/><rect x="16" y="9" width="4" height="11" rx="1.5" fill="#fff" opacity=".85"/></svg>`,
  },
  {
    n: 'CRM',
    c: C.blue,
    shot: `<div class="mshead"></div><div class="msrow w2" style="background:#dcebf9"></div><div class="msrow w1"></div><div class="msrow w2"></div><span class="mstag" style="width:52px;background:#469FD8;opacity:.8"></span><span class="mstag" style="width:26px;background:#34A851;opacity:.7"></span>`,
    ic: `<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="9" cy="9" r="3.2" fill="#fff"/><path d="M3.5 19a5.5 5.5 0 0111 0z" fill="#fff" opacity=".85"/><circle cx="17" cy="10" r="2.4" fill="#fff" opacity=".65"/></svg>`,
  },
  {
    n: 'HRMS',
    c: C.purple,
    shot: `<div class="mshead"></div><div class="msrow w3" style="background:#e6e0f4"></div><div class="msrow w2"></div><div class="msrow w1" style="background:#e6e0f4"></div><span class="mstag" style="width:36px;background:#6C59A6;opacity:.8"></span><span class="mstag" style="width:40px;background:#F2673A;opacity:.6"></span>`,
    ic: `<svg aria-hidden="true" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="3" fill="none" stroke="#fff" stroke-width="2.2"/><path d="M8 12.5l2.5 2.5L16.5 9" stroke="#fff" stroke-width="2.2" fill="none" stroke-linecap="round"/></svg>`,
  },
  {
    n: 'Ask TeamGrid',
    c: C.orange,
    shot: `<div class="mshead"></div><div class="msrow w2" style="background:#fbe3d8"></div><div class="msrow w1"></div><div class="msrow w3"></div><span class="mstag" style="width:58px;background:#F2673A;opacity:.8"></span>`,
    ic: `<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 6a2.5 2.5 0 012.5-2.5h11A2.5 2.5 0 0120 6v8a2.5 2.5 0 01-2.5 2.5H10l-4.5 4v-4H6.5A2.5 2.5 0 014 14z" fill="#fff"/></svg>`,
  },
];

/** Build the same grid order as the original HTML script */
export function buildAppGridItems() {
  const items = [];
  let si = 0;
  const pushCell = (s, dim) =>
    items.push({ type: 'cell', label: s[0], glyph: s[1], color: s[2], dim });
  const pushBig = (i) => items.push({ type: 'big', ...BIG_TILES[i] });

  for (let i = 0; i < 3; i++) pushCell(SMALL_CELLS[si++], i === 0);
  pushBig(0);
  pushBig(1);
  for (let i = 0; i < 3; i++) pushCell(SMALL_CELLS[si++], i === 2);
  for (let i = 0; i < 6; i++) pushCell(SMALL_CELLS[si++], i === 0 || i === 5);
  for (let i = 0; i < 3; i++) pushCell(SMALL_CELLS[si++], i === 0);
  pushBig(2);
  pushBig(3);
  for (let i = 0; i < 3; i++) pushCell(SMALL_CELLS[si++], i === 2);
  for (let i = 0; i < 6; i++) pushCell(SMALL_CELLS[si++], i === 0 || i === 5);
  while (si < SMALL_CELLS.length) pushCell(SMALL_CELLS[si++], si === SMALL_CELLS.length);

  return items;
}
